








































































import { Component, Vue, Prop } from "vue-property-decorator";
import * as util from "@/service/util";
import requestService from "@/service/requestService";
import { MESSAGE } from "@/model/Message";
@Component({
})
export default class CustomerCarListComponent extends Vue {
  @Prop() customerCarSelected: any;
  loadingText: string = MESSAGE.Loading;
  loading: boolean = false;
  public reqService: requestService = new requestService();

  form: any = {
    searchFrom: null,
    searchTo: null
  };

  data: any = [];
  totalSize: number = 0;
  dataPageList: any = [];
  currentPage: number = 1;
  pageSize: number = 10;
  listPlateArea: any = [];

  onSearchCustomerCar() {
    this.currentPage = 1;
    this.totalSize = 0;
    this.data = [];
    this.searchCustomerCar();
  }

  searchCustomerCar() {
    this.$set(this, "loading", true);
    this.reqService.getPlateAreas().then((res: any) => {
      if (res) {
        this.listPlateArea = res;
        this.reqService.getCustomerCarList(this.form, this.currentPage, this.pageSize).then((response: any)=>{
        if (response) {
          this.data = response.results;
          this.totalSize = response.totalSize;
        } else {
          this.totalSize = 0;
          this.currentPage = 1;
          this.data = [];
        }
        this.setDataPage();
        this.$set(this, "loading", false);
      },
      (err: any) => {
        this.data = [];
        this.setDataPage();
        this.$set(this, "loading", false);
      });
      }
    });
  }

  setDataPage() {
    this.$set(this, "dataPageList", this.data);
  }

  handleCurrentChange() {
    this.searchCustomerCar();
  }

  onRowSelect(row: any, event: any, column: any) {
    if (this.customerCarSelected && this.customerCarSelected.syaryouKanriNo === row.syaryouKanriNo
      && this.customerCarSelected.kokyakuKanriNo === row.kokyakuKanriNo ) {
      this.$emit("onSelectCustomerCarRow");
    } else {
      this.$emit("onSelectCustomerCarRow", row);
    }
  }

  tableRowClassName(item: any) {
    if (this.customerCarSelected && this.customerCarSelected.syaryouKanriNo === item.row.syaryouKanriNo
      && this.customerCarSelected.kokyakuKanriNo === item.row.kokyakuKanriNo ) {
      return "row-selected";
    }
    return "";
  }

  plateAreaCd2Nm(item: any) {
    let selectPlateArea = this.listPlateArea.filter((e: any) => {
      return e.plateAreaCd == item.plateAreaCd;
    });

    if (!selectPlateArea || selectPlateArea.length == 0) {
      return "";
    }
    
    return selectPlateArea[0].plateAreaNm
                     + " " + item.plateModelNm
                     + " " + item.plateKanaNm
                     + " " + item.plateNo;

  }

  customerNm(item: any) {
    if (!item || !item.customer) {
      return "";
    }
    if (item.customer.kokyakuKbn == 1) {
      return item.customer.kojinNmKjL + " " + item.customer.kojinNmKjF + " 様";
    } else if (item.customer.kokyakuKbn == 2) {
      return item.customer.houjinNmKj + " 様";
    }
    return "";
  }

  onSelect(row: any) {
  }

}
